import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_LIST_REQUEST,
  CONFIDENTIAL_LIST_SUCCESS,
  CONFIDENTIAL_LIST_FAILURE,
  CONFIDENTIAL_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case CONFIDENTIAL_LIST_SUCCESS:
      return state
        .set('confidential', fromJS(action.payload.employee_confidential))
        .set('isFetching', false)
    case CONFIDENTIAL_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONFIDENTIAL_LIST_RESET:
      return state
        .delete('confidential')
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-list-reducer.js